<div class="custom-table overflow-x-auto mt-[12px]">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_LIST.CLIENTNAME' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_LIST.MOBILENUMBER' | translate }} /
					{{ 'GENERAL_LABELS.EMAIL' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_LIST.BOOKING_COUNT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'CLIENT.CLIENT_LIST.DATE' | translate }}
				</td>

				<td></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let client of clients
						| paginate
							: {
									itemsPerPage: clientFilter?.paging?.pageSize,
									currentPage: clientFilter?.paging?.pageNumber,
									totalItems: totalCount
							  };
					let indx = index
				"
				class="{{
					indx + 1 != clients.length
						? 'border-b-[1px] border-secondry-color-Gray'
						: ''
				}}"
			>
				<td
					[routerLink]="['client-profile', client.id]"
					class="cursor-pointer text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						class="flex items-center rtl:max-mobile:ml-8 ltr:max-mobile:mr-8 relative"
					>
						<img
							class="w-[56px] h-[56px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
							[src]="imagePath + client?.profileImageUrl"
							onerror="this.src='assets/images/logo.png'"
							alt=""
						/>
						<span>
							<span class="text-dark-grey">
								{{ client?.name | slice : 0 : 15 }}
								{{ client.name.length > 15 ? '...' : '' }}
							</span>
						</span>
					</span>
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<h1
						class="text-font-16 text-dark-grey max-mobile:text-font-12 my-0 py-0"
					>
						{{ client?.mobileNumber }}
					</h1>
					<span class="text-medium-gray my-0 py-0 font-Poppins-regular">
						{{ client?.emailAddress }}
						<!-- {{ client?.emailAddress | slice : 0 : 15 }}
						{{ client.emailAddress.length > 15 ? '...' : '' }} -->
					</span>
				</td>
				<td
					class="flex mt-5 text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[16px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ client?.bookingCount }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-dark-grey bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ client?.registrationDate | date : 'dd / MM / yyy' }}
				</td>

				<td
					class="text-font-16 leading-[22px] text-medium-gray bg-grey-background py-[6px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<button [routerLink]="['client-profile', client.id]">
						<span class="inline-block max-mobile:w-[20px] w-[16px] text-end">
							<img
								class="inline-block cursor-pointer"
								[src]="'assets/images/view.svg'"
								alt=""
							/>
						</span>
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
